export const useScrollUtils = () => {
  const prefersReducedMotion = useReducedMotion()

  const goToSavedScrollPosition = (storageKey: string) => {
    if (!window) return

    const savedScrollPosition = sessionStorage.getItem(storageKey)
    if (!savedScrollPosition) return

    window.scrollTo(0, parseInt(savedScrollPosition))
    sessionStorage.removeItem(storageKey)
  }

  const saveScrollPosition = (storageKey: string) => {
    if (!window) return

    sessionStorage.setItem(storageKey, String(window.scrollY))
  }

  const scrollTop = (position = 0, behavior: ScrollBehavior = 'smooth') => {
    if (!window) return

    // An explicit 'smooth' overrides the global `scroll-behavior: auto` reduced-motion rule
    window.scrollTo({
      behavior: prefersReducedMotion.value ? 'instant' : behavior,
      top: position,
    })
  }

  return {
    goToSavedScrollPosition,
    saveScrollPosition,
    scrollTop,
  }
}
